import React, { Dispatch, SetStateAction } from 'react';
import styled, { css } from 'styled-components';
import { ModifyValue } from '../hooks/useProductDetaillHooks';
import { debounce } from 'lodash';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;

  position: sticky;
  bottom: 20px;
  width: 100%;
  z-index: 15;
  pointer-events: none;
`;

const AcceptButton = styled.button<{ $isAbled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;

  border-radius: 99px;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.6px;
  pointer-events: auto;

  ${props =>
    props.$isAbled
      ? css`
          background: #1b1c1e;
          color: #fff;
        `
      : css`
          border: 1px solid #dbdcdf;
          background: #f4f4f5;
          color: #dbdcdf;
        `}
`;

interface SaveButtonIProps {
  isAbled: boolean;
  modifyValue: ModifyValue;
  handleResetItem: () => void;
  handleRegistItem: () => void;
  setModifyValue: Dispatch<SetStateAction<ModifyValue>>;
}

const SaveButton: React.FC<SaveButtonIProps> = props => {
  const {
    isAbled,
    modifyValue,
    handleRegistItem,
    handleResetItem,
    setModifyValue,
  } = props;

  const handleAccept = debounce(() => {
    if (isAbled) {
      handleRegistItem();

      setModifyValue({ ...modifyValue, isModify: true });
    }
  }, 1000);

  return (
    <Container>
      {/* <Text
        color="#989BA2"
        size="16px"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          handleResetItem();

          setModifyValue({ ...modifyValue, isModify: false });
        }}
      >
        원래대로
      </Text> */}
      <AcceptButton $isAbled={isAbled} onClick={handleAccept}>
        수정사항 적용
      </AcceptButton>
    </Container>
  );
};

export default SaveButton;
